export default "__VITE_ASSET__mTHmrsMg__"